import React, { useState, useEffect } from "react";
import "./App.css";
import Header from "./components/header/header";
import HomePage from "./components/HomePage/HomePage";
import Property from "./components/property/proporty";
import List from "./components/list/list";
import Award from "./components/AwardSection/award";
import Locations from "./components/locations/locations";
import Agent from "./components/agents/agent";
import Packages from "./components/packages/package";
import Contact from "./components/contact/contact";
import Footer from "./components/footer/footer";
import AnimatedList from "./animatedList/AnimatedList ";

function App() {
  const [isMobile, setIsMobile] = useState(false);

 
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const sections = {
    homePage: "homePage",
    property: "Property",
    list: "List",
    award: "Award",
    locations: "Locations",
    agent: "Agent",
    packages: "Packages",
    contact: "Contact",
  };

  const content = (
    <>
      <Header sections={sections} />
      <HomePage id={sections.homePage} />
      <Property id={sections.property} />
      <List id={sections.list} />
      <Award id={sections.award} />
      <Locations id={sections.locations} />
      <Agent id={sections.agent} />
      <Packages id={sections.packages} />
      <Contact id={sections.contact} />
      <Footer />
    </>
  );

  return (
    <div className="App">
      {isMobile ? (
       
        content
      ) : (
        
        <AnimatedList
          items={React.Children.toArray(content.props.children)}
          onItemSelect={(item, index) => console.log(item, index)}
          showGradients={true}
          enableArrowNavigation={true}
          displayScrollbar={true}
        />
      )}
    </div>
  );
}

export default App;
